import React from 'react';

import { Section, preloader } from 'spectacle-ppa';

import balloonSlide from '../../baseSlides/balloonSlide';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './teamIntro.md';

import apprenticeHandsHips from '../../images/characters/apprenticeHandsHips.png';

const md = new MarkdownScript(markdownFile);

export function preloadGameShow () {
  preloader([
    apprenticeHandsHips
  ]);
}

function teamIntroSection ({ regionData }) {
  return (
    <Section id="team-intro">

      {/* Get into teams  */}
      {balloonSlide({
        id: 'get-into-teams',
        characterSide: 'right',
        characterImage: apprenticeHandsHips,
        notes: md.getSubSectionAsHtml('Get Into Your Teams', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Get Into Your Teams', 'Content', false, regionData)
      })}

    </Section>

  );
}

export default teamIntroSection;



// WEBPACK FOOTER //
// ./programs/epsHybridAssembly/sections/05_teamIntro/teamIntroSection.jsx